import { render, staticRenderFns } from "./MyCarouselItem.vue?vue&type=template&id=1fd489b6&"
import script from "./MyCarouselItem.vue?vue&type=script&lang=js&"
export * from "./MyCarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./MyCarouselItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports